<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    name: {
      required: true,
      type: String,
    },
    folder: {
      type: String,
      default: "",
    },
  },
  computed: {
    url() {
      return this.folder
        ? new URL(
            `../../assets/icons/${this.folder}/${this.name}.svg`,
            import.meta.url
          ).href
        : new URL(`../../assets/icons/${this.name}.svg`, import.meta.url).href;
    },
  },
});
</script>

<template>
  <img :src="url" :alt="`icon-${name}`" />
</template>
